import React from 'react'

import AudioComponent from './component.jsx'

const AudioContainer = props => {
  const { file } = props || {}
  const { file: audioFile } = file || {}
  const { url } = audioFile || {}
  return <AudioComponent src={url} />
}

AudioContainer.propTypes = {}

export default AudioContainer
